import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getResidueConversionList as getResidueConversionListApi,
	getResidueConversion as getResidueConversionApi,
	addNewResidueConversion as addNewResidueConversionApi,
	updateResidueConversion as updateResidueConversionApi,
	deleteResidueConversion as deleteResidueConversionApi,
	registerResidueConversion as registerResidueConversionApi
} from '../../helpers/residue/backend_helper';

export const getResidueConversionList = createAsyncThunk('residueConversions/getResidueConversionList', async (params) => {
	try {
		const response = getResidueConversionListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getResidueConversion = createAsyncThunk('residueConversions/getResidueConversion', async residueConversionId => {
	try {
		const response = getResidueConversionApi(residueConversionId);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewResidueConversion = createAsyncThunk('residueConversions/addNewResidueConversion', async residueConversion => {
	try {
		const response = addNewResidueConversionApi(residueConversion);
		toast.success('Conversión agregada exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar conversión.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateResidueConversion = createAsyncThunk('residueConversions/updateResidueConversion', async (residueConversion) => {
		try {
			const response = updateResidueConversionApi(residueConversion);
			toast.success('Conversión actualizada exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar conversión.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteResidueConversion = createAsyncThunk('residueConversions/deleteResidueConversion', async residueConversion => {
	try {
		const response = await deleteResidueConversionApi(residueConversion);
		toast.success('Conversión eliminada exitosamente.', { autoClose: 3000 });
		return { residueConversion, ...response };
	} catch (error) {
		toast.error('Error al eliminar conversión.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const getRegisterResidueConversion = createAsyncThunk('residueConversions/getRegisterResidueConversion', async residueConversion => {
	try {
		const response = getRegisterResidueConversionApi(residueConversion);
		console.log(response)
		// toast.success('Guía cargada exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		console.log(error)
		toast.error('Error al obtener datos de conversión.', { autoClose: 3000 });
		throw new Error(error);
	}
});